import React from 'react'
import { ProductThumbnailCard } from 'components/ProductThumbnail'
import { getSelectedVariant } from 'components/UserFavorites/UserRecentlyViewedProducts'
import { getProductRoute } from 'utils/getProductRoute'
import { getProductSlug } from 'utils/getProductSlug'

export const StrapiTrendingProductsProduct = ({ product }) => {
  const mainVariant = getSelectedVariant(product.productVariants)
  return (
    <ProductThumbnailCard
      variantId={mainVariant.legacyId}
      key={product.id}
      title={product.title}
      productImageAlt={
        mainVariant.leadProductImage?.alternativeText || product.title
      }
      productImageUrl={
        mainVariant.leadProductImage?.url || mainVariant.images[0].url
      }
      price={mainVariant.manufacturersSuggestedRetailPrice}
      tradePrice={mainVariant.tradePrice}
      url={getProductRoute({
        slug: getProductSlug({
          id: product.legacyId,
          title: product.title,
        }),
      })}
    />
  )
}
